import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalLayoutComponent } from '@app/components/modals/base/modal-layout/modal-layout.component';

@NgModule({
	declarations: [ModalLayoutComponent],
	exports: [ModalLayoutComponent, ModalModule],
	imports: [ModalModule],
})
export class ModalLayoutModule {}
